import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PatientDetailOverlayService } from '../../../core/services/patient-detail-overlay.service';

@Component({
  selector: 'app-patient-detail-overlay-host',
  standalone: false,
  templateUrl: './patient-detail-overlay-host.component.html',
  styleUrl: './patient-detail-overlay-host.component.css'
})
export class PatientDetailOverlayHostComponent implements OnInit, OnDestroy {
  isOpen = false;
  accountNo: number | null = null;
  initialTab: 'visits' | 'visit-detail' | 'emr' | null = null;
  workflowPatientVisitId: number | null = null;
  workflowAppointmentStatus: number | null = null;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly overlay: PatientDetailOverlayService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.overlay.state$.pipe(takeUntil(this.destroy$)).subscribe((s) => {
      this.isOpen = s.open;
      this.accountNo = s.accountNo;
      this.initialTab = s.initialTab;
      this.workflowPatientVisitId = s.workflowPatientVisitId;
      this.workflowAppointmentStatus = s.workflowAppointmentStatus;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onClose(): void {
    // Swallow stray click-through to the page below (e.g. Sync / table) right after the modal unmounts.
    document.body.style.pointerEvents = 'none';
    try {
      this.overlay.close();
    } finally {
      setTimeout(() => {
        try {
          document.body.style.removeProperty('pointer-events');
        } catch {
          /* ignore */
        }
      }, 200);
    }
  }
}
